export default !!(typeof window !== 'undefined' && window.document && window.document.createElement);


//////////////////
// WEBPACK FOOTER
// ../~/dom-helpers/esm/canUseDOM.js
// module id = 650
// module chunks = 121